// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"9de0b96d","lsc":"e6e95671","others":"ff5de9be"}[chunkId] + ".chunk.js";
};